import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Chips, CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Paper, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { capitalize } from 'lodash';
import { Project, ProjectStatusEnum, ProjectTypeEnum, RoleEnum } from '~/api/types';
import { InfoIcon } from '~/icons';
import { DATE_FORMAT } from '~/utils';
import { projectCardContainerStyles } from './styles';

interface ProjectCardProps {
  project: Project;
}

const ProjectCard: FC<ProjectCardProps> = ({ project }) => {
  const navigate = useNavigate();
  const owner = project?.members?.find(({ role_id }) => RoleEnum.OWNER === role_id);

  const projectChipsConfig = [
    {
      label: project?.status ? capitalize(project.status) : 'Unknown',
      type: project?.status === ProjectStatusEnum.ACTIVE ? 'confirm' : 'critical',
    },
    {
      label: project?.type + ' Project',
      type: 'customSolid',
      customColor: project?.type === ProjectTypeEnum.PRODUCER ? '#F8ECFF' : '#D6FFF8',
      customIcon: <InfoIcon fill={project?.type === ProjectTypeEnum.PRODUCER ? '#C121EB' : '#00DCB9'} />,
    },
    {
      label: project?.members?.length
        ? `${project.members.length} member${project.members.length > 1 ? 's' : ''}`
        : 'Unknown',
      type: 'informative',
    },
  ];

  return (
    <Paper elevation={2} sx={projectCardContainerStyles}>
      <Typography variant="h5" mb="1rem" color="#0C0CA5">
        {project.name}
      </Typography>
      <Typography>{project.description}</Typography>
      <Stack direction="column" mt="24px" gap="1rem">
        <Chips chipsConfig={projectChipsConfig} alignment="left" />
        {owner && <Typography variant="body2">{`Owner: ${owner.first_name} ${owner.last_name}`}</Typography>}
        <Typography variant="body2">
          {`Created by ${
            project?.creator ? `${project?.creator?.first_name} ${project?.creator?.last_name}` : 'system'
          } on ${format(new Date(project.created), DATE_FORMAT)}`}
        </Typography>
        <Stack direction="row" justifyContent="center" mt="24px">
          <CustomButton
            buttonType="outlined"
            label="View Details"
            onClick={() => navigate(`${project.id}`, { relative: 'path' })}
          />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ProjectCard;
